module.exports = __webpack_public_path__ + "static/img/frutuba-guarana.65f1c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/frutuba-guarana.png
// module id = RLGd
// module chunks = 0